import cn from "classnames"

import { Space as SpaceAntd } from "antd"

import styles from "./Space.module.scss"

import type { SpaceProps } from "."

export const Space = ({
  className,
  children,
  inline,
  baseline,
  ...props
}: SpaceProps) => {
  return (
    <SpaceAntd
      className={cn(className, {
        [styles.inline]: inline,
        [styles.baseline]: baseline
      })}
      {...props}
    >
      {children}
    </SpaceAntd>
  )
}

Space.Compact = SpaceAntd.Compact
